<script>
  import HeaderMini from "../components/HeaderMini.svelte";
  import ActionButton from "../components/ActionButton.svelte";
  import { Input, Article, Badge } from "spaper";
  import { strings } from "../constants/strings";
  import { isAdmin, authToken, adminName, surveyFilters } from "../stores/stores";
  import { link, navigate } from "svelte-routing";
  import { adminLogin } from "../utils/utils";
  import { Icon } from "svelte-awesome";
  import {
    faPaw,
    faFileAlt,
    faSignOutAlt,
    faDog
  } from "@fortawesome/free-solid-svg-icons";
  import Footer from "../components/Footer.svelte";

  let username = "";
  let password = "";
  let formError = "";
  $: welcomeMsg = $isAdmin
    ? `¡Hola ${$adminName}!`
    : "Ingresa tus credenciales de acceso";
  const logout = () => {
    isAdmin.set(false);
    navigate("/");
  };

  const login = async () => {
    if (!username || !password) {
      formError = strings.formMessages.validation.allFieldsRequired;
      return;
    }
    let formData = new FormData();
    formData.append("username", username);
    formData.append("password", password);
    try {
      const response = await adminLogin(formData);
      formError = "";
      if (!response.logged) {
        formError = strings.formMessages.validation.wrongCredentials;
      } else {
        adminName.set(response.name);
        isAdmin.set(true);
        authToken.set(
          response[strings.authTokenHeader].split(" ")[1]
        );
        surveyFilters.set("");
      }
    } catch (errorMessage) {
      formError = errorMessage;
    }
  };
</script>

<HeaderMini />
<Article title="Administrador">
  <p slot="textLead">{welcomeMsg}</p>
  <div class="form-group">
    {#if !$isAdmin}
      <Input label="Usuario" bind:value={username} block />
      <Input label="Contraseña" type="password" bind:value={password} block />
    {/if}
    {#if formError != ""}
      <br />
      <br />
      <Badge type="danger">{formError}</Badge>
    {/if}
    <br />
    <br />
    {#if !$isAdmin}
      <ActionButton text="Ingresar" klass="btn-danger" action={login} />
    {:else}
      <div class="row flex-center">
        <div class="col-3 col">
          <a href="/adoptables" use:link class="paper-btn">
            <Icon scale="3" data={faDog} />
          </a>
          <br /><br />
          Adoptables
        </div>
        <div class="col-3 col">
          <a href="/_newadoptable" use:link class="paper-btn btn-success">
            <Icon scale="3" data={faPaw} />
          </a>
          <br /><br />
          Nuevo Adoptable
        </div>
        <div class="col-3 col">
          <a href="/_adoptionrequests" use:link class="paper-btn btn-secondary">
            <Icon scale="3" data={faFileAlt} />
          </a>
          <br /><br />
          Ver Solicitudes
        </div>
        <div class="col-3 col">
            <button class="paper-btn btn-danger" on:click={logout}>
              <Icon scale="3" data={faSignOutAlt} />
            </button>
            <br /><br />
            Cerrar Sesión
        </div>
      </div>
    {/if}
  </div>
</Article>
<Footer />